export const blockTimerForNSeconds = async (timer: number = 1000) => {
  await new Promise((resolve) => setTimeout(resolve, timer));
};
